export enum MarginalEmploymentType {
  Yes = 'yes',
  No = 'no',
  OnlyPfk = 'marginal_only_pfk',
  OnlyHk = 'marginal_only_hk',
}

export const MARGINAL_EMPLOYMENT_TYPE_TRANSLATIONS = {
  [MarginalEmploymentType.Yes]: 'Ja',
  [MarginalEmploymentType.No]: 'Nein',
  [MarginalEmploymentType.OnlyPfk]: 'GFB nur für PFK',
  [MarginalEmploymentType.OnlyHk]: 'GFB nur für HK',
};
